import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function O2TableRow(props) {
  var children = props.children,
      className = props.className,
      opacity = props.opacity,
      loadMore = props.loadMore,
      internal = props.internal,
      link = props.link,
      total = props.total,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "opacity", "loadMore", "internal", "link", "total"]);

  var classes = classNames(className, opacity ? "o2-table__" + opacity + "-row" : false, {
    'o2-table__load-more': loadMore,
    'o2-table__row--internal': internal,
    'o2-table__link-row': link,
    'o2-table__total': total
  });
  return /*#__PURE__*/React.createElement("tr", _extends({}, attributes, {
    className: classes
  }), children);
}

O2TableRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  opacity: PropTypes.oneOf(['transparent', 'semitransparent']),
  loadMore: PropTypes.bool,
  internal: PropTypes.bool,
  link: PropTypes.bool,
  total: PropTypes.bool
};
export default O2TableRow;